<template>
    <div>
        <nav-breadcrumb :menu="[{label: '发起他项出库'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "HisWarrantCheckoutList",
        data(){
            return{
                status: 'IN',
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                   /* {
                        label: '手机号',
                        field: 'c__customerContactNo'
                    },*/
                    {
                        label: '贷款状态',
                        field: 'fi__transactionStatus',
                        formatter: function (r,c,v) {
                            return Status2CN('Financing_'+v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '出库',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'Create',
                                            query: {
                                                transactionId: row.fi__transactionId
                                            }
                                        }
                                    )
                                }
                            },
                        ]
                    }
                ],

                tableData: {
                    count: 0,
                    data: []
                },

                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        c__customerContactNo:'',
                        c__customerName:'',
                        fi__transactionNo:''
                    },
                    columns: [
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo'
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'c__customerName'
                        },
                       /* {
                            label: '手机号',
                            component: 'el-input',
                            field: 'c__customerContactNo'
                        },*/

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
            }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getFinancingForHisWarrantCheckout(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantCheckoutList.vue